import { useContext } from 'react';
import { FootnoteReferenceDispatchContext } from '../components/FootnoteReferenceContext';
export const useFootnoteReferenceDispatch = () => {
    const dispatch = useContext(FootnoteReferenceDispatchContext);
    if (dispatch === undefined) {
        throw new Error('useFootnoteReferenceDispatch must be used within a FootnoteReferenceContextProvider');
    }
    return dispatch;
};
